export const PushCampaignAPI = {
  campaign: {
    // Admin marketing push campaigns
    list: '/marketing/campaigns',
    detail: '/marketing/campaigns/:id',
    create: '/marketing/campaigns',
    stop: '/marketing/campaigns/:id/stop',
    schedule: '/push_campaigns/:id/schedule',
    update: '/marketing/campaigns/:id',
  },
}
